export default "__VITE_ASSET__3ca1004d__"